export default __webpack_public_path__ + "static/media/friends.b02177c2.svg";